import { createSelector } from '@reduxjs/toolkit';
import type { IModuleNavigationDetail } from 'core/model/interfaces/module-navigation.interface';
import type { IState } from 'core/store/reducers';

const selectModuleNavigationState = (state: IState) => state.moduleNavigation;
export const selectSelectedPlatform = (state: IState) => state.platform.selectedPlatform;

export const selectIsModuleNavigationLoading = createSelector(selectModuleNavigationState, state => state.isLoading);

export const selectAllModulesNavigationByPlatform = createSelector(
  [selectModuleNavigationState, selectSelectedPlatform],
  (moduleNavigation, selectedPlatform): Array<IModuleNavigationDetail> => {
    if (!moduleNavigation) return [];

    const platformModules = moduleNavigation.modulesByPlatform.find(
      platform => platform.platformId === selectedPlatform,
    );

    return platformModules?.modules || [];
  },
);
